import angular from 'angular';
import { ITipoRelatorioSolicitacaoResponse } from './models/tipos-relatorios-solicitacoes.service.model';
import { NsjRoutingType } from '@core/nsj-core';

/**
 * Tipos de relatório de solicitação (meurh.tiposrelatoriossolicitacoes).
 *
 * Cada registro é um documento do kit da solicitação (ex.: os documentos do kit admissional).
 * `requerassinatura` define se o documento vai para o colaborador pedindo assinatura — registro
 * global (tenant nulo) é modelo padrão da Nasajon e não é editável pelo cliente.
 */
export class TiposRelatoriosSolicitacoesService {
    static $inject = ['$http', 'nsjRouting', '$q'];

    public listBusy = false;
    public updateBusy = false;

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: NsjRoutingType,
        public $q: angular.IQService,
    ) {}

    public getList(constructors: Record<string, any> = {}) {
        this.listBusy = true;

        return this.$q<ITipoRelatorioSolicitacaoResponse[]>((resolve, reject) => {
            this.$http
                .get<ITipoRelatorioSolicitacaoResponse[]>(
                    this.nsjRouting.generate('meurh_tiposrelatoriossolicitacoes_index', constructors, true)
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error))
                .finally(() => {
                    this.listBusy = false;
                });
        });
    }

    /**
     * Altera só a exigência de assinatura. Não usa o PUT do tipo de relatório porque ele revalida o nome, e
     * tipos criados automaticamente na geração do relatório podem ter nomes fora da regra do formulário.
     */
    public updateRequerassinatura(tiporelatorio: number, requerassinatura: boolean) {
        this.updateBusy = true;

        return this.$q<ITipoRelatorioSolicitacaoResponse>((resolve, reject) => {
            this.$http
                .patch<ITipoRelatorioSolicitacaoResponse>(
                    this.nsjRouting.generate(
                        'meurh_tiposrelatoriossolicitacoes_patch_requerassinatura',
                        { id: tiporelatorio },
                        true
                    ),
                    { requerassinatura }
                )
                .then((response) => resolve(response.data))
                .catch((error) => reject(error))
                .finally(() => {
                    this.updateBusy = false;
                });
        });
    }
}

angular.module('main').service('TiposRelatoriosSolicitacoesService', TiposRelatoriosSolicitacoesService);
